import axios, { AxiosError, AxiosResponse } from 'axios';
import { getBackendUrl } from './utils/environments';
import getOktaProvider from './OktaProvider';
import { APP_URL, LOGIN_SCREEN_ROUTE } from './config';

const axiosInstance = axios.create({
  baseURL: getBackendUrl(),
  timeout: 60000,
  headers: { Accept: 'application/json' },
  transitional: {
    silentJSONParsing: false,
    forcedJSONParsing: true,
    clarifyTimeoutError: true,
  },
});

axiosInstance.interceptors.response.use(
  async (response: AxiosResponse): Promise<AxiosResponse> => {
    return response;
  },
  (error: AxiosError) => {
    if (error.code === 'ECONNABORTED') {
      console.log('Network timeout');
    } else if (error.response) {
      if (error.response.status === 401) {
        const oktaAuth = getOktaProvider();
        oktaAuth.signOut({
          postLogoutRedirectUri: APP_URL + LOGIN_SCREEN_ROUTE,
        });
        return;
      }
      if (error.response.status === 404) {
        console.log('Wrong endpoint:', error.response.status);
      } else {
        console.log('API failure:', error.response.status);
      }
    } else {
      console.log('Other error:', error.message);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
